<script>
import { BNavForm } from "bootstrap-vue";

export default {
  extends: BNavForm
};
</script>